import { CalendarDaysIcon } from '@heroicons/react/24/solid';
import React from 'react';

type Props ={
  date: string,
}

export default function VideoDate({ date } : Props) {
  return (
    <p className="flex items-center mr-3 font-semibold tracking-wider md:mr-8 text-chdGreen-light whitespace-nowrap">
      <CalendarDaysIcon className="mr-1 w-[1rem]" fill="white" />
      {' '}
      {date}
    </p>
  );
}
